// Only initialize if not embedded in an iFrame
if (window.top === window.self) {
  window.addEventListener('DOMContentLoaded', function () {
    var $flyout = document.querySelector('.aps-flyout')

    if ($flyout) {
      var $topBlock = document.querySelector('.topBlock')
      
      // Close flyout when overlay area is clicked
      $flyout.addEventListener('click', function (ev) {
        if (ev.target.classList.contains('aps-flyout')) {
          $flyout.classList.remove('aps-flyout--active')
        }
      })

      $flyout.addEventListener('transitionend', function () {
        if (!$flyout.classList.contains('aps-flyout--active')) {
          $flyout.style.display = 'none'
          // Remove scroll lock
          if ($topBlock) $topBlock.style.maxWidth = 'unset'
          document.documentElement.style.maxWidth = 'unset'
          document.documentElement.style.overflowY = 'auto'
        }
      })

      $flyout.querySelector('.aps-flyout__close').addEventListener('click', function (ev) {
        ev.preventDefault()
        ev.stopPropagation()
        $flyout.classList.remove('aps-flyout--active')
      })

      var $container = $flyout.querySelector('.aps-flyout__iframe-container')
      var $iframe = $container.querySelector('iframe')

      var unloadHandler = function () {
        if (document.readyState === 'complete') {
          $container.classList.add('is-loading')
          // Timeout needed because iFrame src changes immediately after unload event is dispatched
          setTimeout(function () {
            if ($iframe.contentDocument.location.href !== 'about:blank') {
              $flyout.style.display = 'block'
              setTimeout(function () {
                // Scroll lock content behind flyout, while avoiding content shift
                document.documentElement.style.maxWidth = document.body.clientWidth + 'px'
                if ($topBlock) $topBlock.style.maxWidth = document.body.clientWidth + 'px'
                document.documentElement.style.overflowY = 'hidden'
                $flyout.classList.add('aps-flyout--active')
              }.bind(this), 1)
            } else {
              $flyout.classList.remove('aps-flyout--active')
            }
          }.bind(this), 1)
        }
      }

      // Listening for the unload event allows opening the flyout immediately after user click, before its content has loaded
      function addUnloadListener() {
        // Remove the unload listener, just in case it was already attached
        $iframe.contentWindow.removeEventListener('unload', unloadHandler)
        $iframe.contentWindow.addEventListener('unload', unloadHandler)
      }

      addUnloadListener()

      // Show flyout content when iframe src is changed/loaded
      $iframe.addEventListener('load', function () {
        if ($iframe.contentDocument.location.href !== 'about:blank') {
          addUnloadListener()
          // Make iframe document aware it's embedded in the flyout
          $iframe.contentDocument.documentElement.classList.add('is-flyout')
          // Delay showing iFrame content for a few animation frames to avoid content shift
          setTimeout(function () {
            $container.classList.remove('is-loading')
          }.bind(this), 256)
        }
      })

      // Clear iFrame content (location href) so the flyout doesn't unexpectedly open when reloading or navigating back to the page
      window.addEventListener('beforeunload', function () {
        $iframe.src = ''
      }.bind(this))

      window.aps.$flyout = $flyout
    }
  })
} else {
  // If page is in flyout iFrame, its links should open in the parent frame
  const $base = document.createElement('base')
  $base.target = '_parent'
  document.head.appendChild($base)
}
